/**
 * Shared location registry — single source of truth for the frontend.
 *
 * Matches the backend's location_utils.py KNOWN_LOCATIONS.
 * Import this instead of duplicating getAirportName() everywhere.
 */

const LOCATIONS = [
  // Airports
  { key: 'JFK',   label: 'JFK - John F. Kennedy Airport',  type: 'airport' },
  { key: 'LGA',   label: 'LGA - LaGuardia Airport',        type: 'airport' },
  { key: 'EWR',   label: 'EWR - Newark Liberty Airport',   type: 'airport' },
  { key: 'BDL',   label: 'BDL - Bradley International',    type: 'airport' },
  { key: 'Tweed', label: 'Tweed - New Haven Airport',      type: 'airport' },

  // Campus pickup spots
  { key: 'Phelps Gate',       label: 'Phelps Gate',         type: 'campus' },
  { key: 'Benjamin Franklin', label: 'Benjamin Franklin',   type: 'campus' },
  { key: 'Silliman',          label: 'Silliman',            type: 'campus' },
  { key: 'PWG',               label: 'PWG',                 type: 'campus' },
];

/** Lookup display label for a location value (handles known, custom:, and legacy). */
export function getLocationDisplay(value) {
  if (!value) return 'Unknown';
  const loc = LOCATIONS.find(l => l.key === value);
  if (loc) return loc.label;
  if (value.startsWith('custom:')) return value.slice('custom:'.length);
  return value;
}

/** Short display — just the key or custom text. */
export function getLocationShort(value) {
  if (!value) return '?';
  if (value.startsWith('custom:')) return value.slice('custom:'.length);
  return value;
}

export default LOCATIONS;
